// extracted by mini-css-extract-plugin
module.exports = {"login":"Login_login__2KFtx","input":"Login_input__2SD-M","loginButton":"Login_loginButton__2zFtg"};